import {CircularProgress, Container, Grid, Typography} from '@mui/material';

export default function LoadingPage() {
  return (
    <Container sx={{padding: 0, height: '100vh', width: '100vw'}}>
      <Grid
        direction="column"
        justifyContent="center"
        alignItems="center"
        container
        sx={{
          height: '100%',
          width: '100%',
          backgroundColor: 'background.default',
        }}
      >
        <CircularProgress
          size={60}
          thickness={4}
          sx={{
            color: 'primary.main',
            animation: 'pulse 1.5s ease-in-out infinite',
            '@keyframes pulse': {
              '0%': {
                opacity: 1,
                transform: 'scale(1)',
              },
              '50%': {
                opacity: 0.7,
                transform: 'scale(0.85)',
              },
              '100%': {
                opacity: 1,
                transform: 'scale(1)',
              },
            },
          }}
        />
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            color: 'text.primary',
            animation: 'fadeInOut 1.5s ease-in-out infinite',
            '@keyframes fadeInOut': {
              '0%': {opacity: 0.5},
              '50%': {opacity: 1},
              '100%': {opacity: 0.5},
            },
          }}
        >
          Loading...
        </Typography>
      </Grid>
    </Container>
  );
}
